export default __webpack_public_path__ + "static/media/information--end-of-advisory-maximum-speed-limit-70--g1.a14754dc.png";